import React from 'react';
import Icon from '../../../components/AppIcon';


const ScoringBreakdown = ({ leads = [], onScoreUpdate }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 50) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getScoreBg = (score) => {
    if (score >= 80) return 'bg-green-50';
    if (score >= 50) return 'bg-yellow-50';
    return 'bg-red-50';
  };

  if (leads?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-12 text-center">
        <Icon name="BarChart3" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
        <p className="text-muted-foreground">No leads available for scoring breakdown</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {leads?.slice(0, 10)?.map((lead, index) => (
        <div key={lead?.id || index} className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <h3 className="font-semibold text-foreground">{lead?.name || lead?.email || 'Unknown'}</h3>
              <p className="text-sm text-muted-foreground">{lead?.company || ''}</p>
              {lead?.insights?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {lead?.insights?.map((insight, i) => (
                    <span key={i} className="text-xs bg-muted text-muted-foreground px-2 py-1 rounded">{insight}</span>
                  ))}
                </div>
              )}
            </div>
            <div className={`p-4 rounded-lg ${getScoreBg(lead?.lead_score || 0)} ml-4 text-center min-w-[80px]`}>
              <p className={`text-2xl font-bold ${getScoreColor(lead?.lead_score || 0)}`}>{lead?.lead_score || 0}</p>
              <p className="text-xs text-muted-foreground">Score</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScoringBreakdown;